module.exports = __webpack_public_path__ + "img/2_gif.b3eab2f3.gif";